module.exports = __webpack_public_path__ + "media/images/gallery/constellations/pegasus/peg_gc-02f9aa72e74870bbd0f0bc76f7321eba.gif";